// web-staking-estimator-frontend/src/utils/map/graphicsHelpers.js

/**
 * Check if a graphic is tagged as a user point
 * @param {object} graphic - ESRI Graphic object
 * @returns {boolean} True if this is a user-placed point
 */
export function isUserPoint(graphic) {
  try {
    return graphic?.attributes?.__userPoint === true;
  } catch {
    return false;
  }
}

// Remove all user-placed points from map layer - used on reset or when user clicks new location
export function pruneUserPoints(layer) {
  if (!layer?.graphics) return;
  
  const toRemove = [];
  try {
    layer.graphics.forEach((g) => {
      if (isUserPoint(g)) toRemove.push(g);
    });
  } catch {}
  
  toRemove.forEach((g) => {
    try {
      layer.remove(g);
    } catch {}
  });
}
